import { Ref } from 'react';
import styles from './TextField.module.css';

interface TextFieldProps {
  className?: string;
  placeholder: string;
  value: string;
  disabled?: boolean;
  textareaRef?: Ref<HTMLTextAreaElement>;
  onChange: (_ev: React.FormEvent<HTMLTextAreaElement>, newValue?: string) => void;
  onKeyDown?: React.KeyboardEventHandler<HTMLTextAreaElement>;
}

export const TextField = ({
  className,
  placeholder,
  value,
  disabled = false,
  textareaRef,
  onChange,
  onKeyDown,
}: TextFieldProps) => {
  return (
    <textarea
      ref={textareaRef}
      className={`${className ? className + ' ' : ''}${styles.textField}`}
      placeholder={placeholder}
      value={value}
      disabled={disabled}
      onChange={(event) => {
        onChange(event, event.target.value);
      }}
      onKeyDown={onKeyDown}
    />
  );
};
